module.exports = __webpack_public_path__ + "static/Apercu-Italic-6071e0549bc06c7a161138907afc8998.ttf";